


























































































































































































import { Vue, Component } from 'vue-property-decorator'
import { mixins } from 'vue-class-component'
import DateOption from '@/mixins/dateOption'
import { getChannelData } from '@/api/datas/distribution'
import { dataCenterIos, dataCenterAndroid, dataCenterBanner, dataCenterSpecial, getBannerData, getSpecialData } from '@/api/datas/content'
import { getChaos, getCookie, getImgURLOfBase64 } from '@/utils/fix'
import { formatJson, resetObjValue2NoneString } from '@/utils/tool'
import { exportJson2Excel } from '@/utils/excel'

@Component({
  name: 'DatasDistribution'
})
export default class extends mixins(DateOption) {
  // api data
  private params = {
    lang: '', // 语言渠道
    entityType: 'ios', // 应用类型(“ios”或“android”)
    reportDateStart: '', // 统计开始时间
    reportDateEnd: '',
    entityId: '', // 应用 ID
    orderBy: '', // 排序方式 （例子：按下载量倒序“download_count desc”，按下载量顺序“download_count”）
    page: 1, // 统计结束时间
    pageCount: 20
  }

  private langs: string[] = []

  // template data
  tableLoading = false
  private value: any[] = [] // 级联选中项
  private dateArray: string[] = ['', '']
  private tableData: any[] = []
  private totalCount: number = 0
  private channels: any[] = []
  private positions: any = {
    ios: [],
    android: []
  }
  private position: string = 'all'
  tableHeight: number = 500
  limit: number = 500

  // lifecycle
  created() {
    this.getOptions()
    this.getTableData()
  }

  mounted() {
    this.$nextTick(() => {
      this.setTableHeight()
      window.addEventListener('resize', this.setTableHeight)
    })
    this.$once('hook:beforeDestroy', () => {
      window.removeEventListener('resize', this.setTableHeight)
    })
  }

  updated() {
    this.$nextTick(() => {
      const table: any = this.$refs.tableData
      table.doLayout()
    })
  }

  // methods
  getOptions() {
    let ios: any = dataCenterIos()
    let android: any = dataCenterAndroid()
    Promise.all([ios, android]).then((result) => {
      let [ios, android] = result
      this.positions = {
        ios: this.formatOption(ios),
        android: this.formatOption(android)
      }
      this.tableLoading = false
    }).catch((error) => {
      console.log(error)
    })
  }

  setTableHeight() {
    const table: any = this.$refs.tableData
    const tableDom: HTMLTableElement = table.$el
    const { top } = tableDom.getBoundingClientRect()
    let height: number = document.body.clientHeight - top - 75
    this.tableHeight = height
  }

  formatDate(date: string) {
    return date.split('T')[0].replaceAll('-', '/')
  }
  async getTableData() {
    this.tableLoading = true
    this.tableData = []
    let map = new Map([['all', getChannelData], ['special', getSpecialData], ['banner', getBannerData]])
    let func: any = map.get(this.position)
    let res: any = await func(this.params)
    let dataList = res.data.dataList || []
    this.tableData = dataList
    this.tableLoading = false
    this.totalCount = res.data.pageInfo.totalCount
  }
  formatOption({ data }: any) {
    data = data || []
    return data.map(({ code, name }: any) => ({ value: code, label: name }))
  }
  handleSelectOne(v: string[]) {
    console.log(v)
    this.params.entityType = v[0]
    this.params.lang = v[1]
  }
  handleDateChange(date: string[]) {
    this.params.reportDateStart = date && date[0]
    this.params.reportDateEnd = date && date[1]
  }
  handleSearch() {
    if (this.tableLoading) { return false }
    let params:any = { ...this.params }
    for (let i in params) {
      if (typeof params[i] === 'string') {
        params[i] = params[i].trim()
      }
    }
    this.params = params
    this.params.page = 1
    this.getTableData()
  }
  getSummaries(param: any) {
    const { columns, data } = param
    const sums: any[] = []
    columns.forEach((column: { property: string|number }, index: number) => {
      if (index === 0) {
        sums[index] = '总计'
      } else if (index >= 5 && index <= 10) {
        const values = data.map((item: { [x: string]: any }) => Number(item[column.property]))
        if (!values.every((value: number) => isNaN(value))) {
          sums[index] = values.reduce((prev: any, curr: any) => {
            const value = Number(curr)
            if (!isNaN(value)) {
              return prev + curr
            } else {
              return prev
            }
          }, 0)
        } else {
          sums[index] = 'N/A'
        }
      } else {
        sums[index] = '--'
      }
    })
    return sums
  }
  handleReset() {
    let platform = this.params.entityType
    this.langs = []
    resetObjValue2NoneString(this.params, ['page', 'pageCount'])
    this.params.page = 1
    this.params.reportDateStart = ''
    this.params.reportDateEnd = ''
    this.params.lang = ''
    this.params.entityType = platform
    this.dateArray = ['', '']
    console.log(this.params)
    this.getTableData()
  }
  handleTabchange() {
    this.params.page = 1
    this.params.reportDateStart = ''
    this.params.reportDateEnd = ''
    this.params.lang = ''
    this.dateArray = ['', '']
    this.getTableData()
  }
  handleSort({ order, prop }: any) {
    if (order === '') {
      this.params.orderBy = ''
    } else if (order === 'descending') {
      this.params.orderBy = prop + ' desc'
    } else {
      this.params.orderBy = prop
    }
    this.getTableData()
  }
  handleSelect(val: string[]) {
    let copy = [...val]
    if (val.includes('all')) {
      if (copy.pop() === 'all') (this.params.lang = 'all') && (this.langs = ['all'])
      else (this.langs = val.filter(el => el !== 'all')) && (this.params.lang = this.langs.toString())
    } else this.params.lang = val.toString()
  }
  async handleExcel() {
    let map = new Map([['all', getChannelData], ['special', getSpecialData], ['banner', getBannerData]])
    let params = { ...this.params }
    params.page = 1
    params.pageCount = this.totalCount > this.limit ? this.limit : this.totalCount
    let func: any = map.get(this.position)
    let res: any = await func(params)
    if (res.status.code === 0) {
      setTimeout(() => {
        this['$message'].success('导出成功!')
      }, 200)
    } else {
      this['$message'].error('导出失败!')
      return
    }
    let tableData = res.data.dataList || []
    const filterVal: string[] = [
      'id',
      'entity_id',
      'lang',
      'icon',
      'name',
      'view_count',
      'download_count',
      'install_count',
      'comment_count',
      'score_count',
      'favorite_count',
      'report_date'
    ]
    const theader: string[] = [
      'ID',
      '应用ID',
      '语言',
      'ICON',
      '应用名称',
      '查看数量',
      '下载次数',
      '安装数量',
      '评论次数',
      '评分次数',
      '收藏次数',
      '统计日期'
    ]
    const list = tableData
    const data = formatJson(filterVal, list)
    exportJson2Excel(theader, data)
  }
}
